import React, { useEffect, useState } from "react";
import s from './DistrictsDropdown.module.scss';
import i18n from 'i18next';

export default function DropdownGPS({ apiUrl, placeholder = "Выберите значение", onChange }) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [selected, setSelected] = useState("");
  const currentLanguage = i18n.language;

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        setError("");
        console.log(apiUrl);
        console.log("apiUrl");
        const response = await fetch(apiUrl);
        if (!response.ok) {
          throw new Error(`Ошибка загрузки: ${response.status}`);
        }
        const data = await response.json();
        
        const objects_json = JSON.parse(data);
        var objects = [];

        for (var i = 0; i < objects_json.length; i++){
            var obj = objects_json[i];
            var radius = 0.06;
            // console.log(obj)
            // console.log(`new element!!!! ${i}`);
            var element = {};
            element['id'] = obj['pk'];
            element['be'] = obj['fields']['name_be'];
            element['en'] = obj['fields']['name_en'];
            element['ru'] = obj['fields']['name_ru'];
            element['lat'] = parseFloat(obj['fields']['lat']) + (Math.random() * 2 - 1) * radius;
            element['lng'] = parseFloat(obj['fields']['lng']) + (Math.random() * 2 - 1) * radius;
            objects.push(element);
            // for (var key in obj){
            //     var value = obj[key];
            //     // console.log(`key ${key} - value ${value}`);
            // }
        }

        setOptions(objects); // Предполагаем, что API возвращает массив
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [apiUrl]);

  const handleChange = (e) => {
    const value = e.target.value;
    setSelected(value);
    if (onChange) {
      onChange(value);
    }
  };

  if (loading) return <p>Загрузка...</p>;
  if (error) return <p style={{ color: "red" }}>Ошибка: {error}</p>;

  return (
    <div className={s.dropdown_wrapper}>
      <select
        className={s.dropdown}
        value={selected}
        onChange={handleChange}
      >
        <option value="">{placeholder}</option>
        {options.map((item) => ( 
          <option name="district" key={item.id} value={JSON.stringify(item)}>
            {item[currentLanguage.toLowerCase()]}
          </option>
        ))}
      </select>
    </div>
  );
}
